import {pathname} from "../../../common/others/Configuration";
import Backbone from "backbone";

export default Backbone.Model.extend({

  validationOptions: {
    cellPhoneRegex: '^0[6-7][0-9]{8}$|^00[0-9]{11,13}$',
    cellPhoneRegexError: '',
    emptyEmailAddressError: ''
  },

  baseUrl: function() {
    // TODO move to account configuration
    return [pathname, '/myaccount/api/v1/contact/'].join('');
  },

  validate: function(attrs) {

    if (typeof attrs.EmailAddress === 'string' && !attrs.EmailAddress) {
      return this.validationOptions.emptyEmailAddressError;
    }

    if (typeof attrs.CellPhone === 'string') {
      var phoneNumberRegex = new RegExp(this.validationOptions.cellPhoneRegex);
      var regexResult = phoneNumberRegex.exec(attrs.CellPhone);
      if (!regexResult || !regexResult.length) {
        return this.validationOptions.cellPhoneRegexError;
      }
    }
  },

  updateCellPhoneNumber: function(cellPhone, options) {
    this.clear({ silent: true });
    this.url = [this.baseUrl(), 'cellphone'].join('');
    this.idAttribute = 'CellPhone';
    return this.save({
      CellPhone: cellPhone
    }, options);
  },

  updateEmail: function(email, options) {
    this.clear({ silent: true });
    this.url = [this.baseUrl(), 'email'].join('');
    this.idAttribute = 'EmailAddress';
    return this.save({
      EmailAddress: email
    }, options);
  }

});
